import { Component, Inject, Optional } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BusinessUnitTypeEnum } from '@max/shared/enums/business-unit-type.enum';
import { MVMDropDownModel } from '@max/shared/models/mvm-drop-down/mvm-drop-down.model';
import { map } from 'rxjs/operators';
import { AuthService } from '../../../../auth/services/auth.service';
import { AccessControlType } from '../../../../foundation/models/enums/access-control-type.enum';
import { FinanceSharedService } from '../../services/finance-shared.service';
import { FinanceBaseComponent } from '../finance-base-component/finance-base.component';

export class CashDrawerConfirmationData {
    public businessUnitTypeId: number;
    public message: string;
    constructor(public cashDrawerConfirmationData: any) {}
}

@Component({
    selector: 'cashdrawer-confirmation-modal',
    templateUrl: './cashdrawer-confirmation-modal.html'
})
export class CashDrawerConfirmationModal extends FinanceBaseComponent {

    // Gets or sets the form.
    public form: UntypedFormGroup;

    // Gets or sets title
    public readonly title: string = 'Verify Cash Drawer';

    // True if the user is able to select a POS device (e.g. if they are in a FOOF office), false otherwise
    public isPOSAvailable = false;

    // Gets or sets the POS Device Dropdown
    public posDeviceDropdown: Array<MVMDropDownModel<number>>;

    // Indicates whether the form has been submitted
    public isSubmitted = false;

    // An enum containing features that require certain permissions to access
    private readonly accessControlType: AccessControlType = new AccessControlType();

    /**
     * Constructs the modal dialog
     * @param dialog The dialog reference and dialog data
     */
    constructor(
        public dialogRef: MatDialogRef<CashDrawerConfirmationData>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: CashDrawerConfirmationData,
        private formBuilder: UntypedFormBuilder,
        public financeService: FinanceSharedService,
        private authService: AuthService
    ) {
        super();
    }

    /**
     * Not implemented
     */
    public ngOnInit() {
        this.initPageData();
    }

    /**
     * Initializes the page data.
     */
    public initPageData() {
        if (this.data.businessUnitTypeId == BusinessUnitTypeEnum.OOFCustServiceOffice) {
            this.isPOSAvailable = true;
            this.getPointOfSaleDevices();
        }

        this.createForm();
    }

    /**
     * Initializes the form
     */
    private createForm() {
        const isWaivePOSDeviceRequirementAccessControlPresent = this.authService.hasACSTransactionClaimEx(this.authService.acsTransactionClaim, this.accessControlType.WaivePOSDeviceRequirement.value);
        const isPOSRequired = this.isPOSAvailable && !isWaivePOSDeviceRequirementAccessControlPresent;
        this.form = this.formBuilder.group({
            'pointOfSaleDeviceId': [null, isPOSRequired ? Validators.required : null]
        });
    }

    /**
     * Gets the point of sale devices for the dropdown
     */
    private getPointOfSaleDevices() {
        this.financeService.getPointOfSaleDevices()
            .pipe(map(r => r.result))
            .subscribe({
                next: r => {
                    this.posDeviceDropdown = r.map(d => ({ value: d.id, label: d.pointOfSaleDeviceValue }));
                    this.posDeviceDropdown.unshift({ value: null, label: '- Select -'});
                },
                error: e => this.handleValidationResult(e)
            });
    }

    /**
     * Not implemented
     */
    public setPageData() {
    }

    /**
     * Closes the modal dialog with the fiscal year to copy from
     */
    public close() {
        this.dialogRef.close();
    }

    public confirm() {
        this.isSubmitted = true;
        this.dialogRef.close(this.form.value);
    }
}
